import classNames from "classnames";
import {Fragment} from "react";

import {generateAssetVerificationBadgeAttributes} from "./AssetVerificationBadge.utils";
import Tooltip from "../../component/tooltip/Tooltip";
import TooltipContent from "../../component/tooltip/content/TooltipContent";
import {PeraLabeledAsset} from "../util/assetModels";

import "./_asset-verification-badge.scss";

interface AssetVerificationBadgeProps {
  verificationTier: PeraLabeledAsset["verification_tier"];
  mode?: "compact" | "verbose";
  assetId?: string;
  customClassName?: string;
}

function AssetVerificationBadge({
  verificationTier,
  customClassName
}: AssetVerificationBadgeProps) {
  const {altText, description, iconSrc} =
    generateAssetVerificationBadgeAttributes(verificationTier);

  const Icon = (
    <img src={iconSrc} alt={altText} className={"asset-verification-badge__icon"} />
  );

  return renderContent();

  function renderContent() {
    if (verificationTier !== "unverified") {
      return (
        <Tooltip
          content={<TooltipContent>{description}</TooltipContent>}
          customClassName={classNames(
            "asset-verification-badge-tooltip",
            customClassName
          )}>
          {Icon}
        </Tooltip>
      );
    }

    return <Fragment />;
  }
}

export default AssetVerificationBadge;
